export default new RegExp(/^[a-zA-Z0-9\s\-]*$/)